import { selectLegalTab } from '../../store/general/selectors';
import { useDispatch, useSelector } from '../../store/store';
import { setLegalTab } from '../../store/general/slice';
import ApplicantTerms from './ApplicantTerms';
import PrivacyPolicy from './PrivacyPolicy';
import EmployerTerms from './EmployerTerms';
import { useEffect, useRef } from 'react';
import styles from './style.module.scss';
import DropDown from '../../components/DropDown';
import { LegalTab } from '../../store/general/types';

interface DropDownItem {
    title: string;
    id: LegalTab;
};

const dropDownList: DropDownItem[] = [
    {
        title: 'Privacy Policy',
        id: 'Privacy_Policy',
    },
    {
        title: 'Terms of Use for Employers',
        id: 'Employer_Terms',
    },
    {
        title: 'Terms of Use for Applicant',
        id: 'Applicant_Terms',
    },
];

export default function Legal() {
    const dispatch = useDispatch();
    const tab = useSelector(selectLegalTab);
    const contentRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        setTimeout(() => {
            contentRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
        }, 0);
    }, [tab]);

    return (
        <div className={styles.container}>
            <div className={styles.tabs}>
                <span
                    className={styles.tabs_item}
                    data-is-active={tab === 'Privacy_Policy'}
                    onClick={() => dispatch(setLegalTab('Privacy_Policy'))}
                >
                    Privacy Policy
                </span>
                <span
                    className={styles.tabs_item}
                    data-is-active={tab === 'Employer_Terms'}
                    onClick={() => dispatch(setLegalTab('Employer_Terms'))}
                >
                    Terms of Use for Employers
                </span>
                <span
                    className={styles.tabs_item}
                    data-is-active={tab === 'Applicant_Terms'}
                    onClick={() => dispatch(setLegalTab('Applicant_Terms'))}
                >
                    Terms of Use for Applicant
                </span>
            </div>

            <DropDown
                idKey='id'
                titleKey='title'
                dropDownList={dropDownList}
                containerClassName={styles.dropdown}
                selectedItem={dropDownList.find(i => i.id === tab)}
                setItem={(item: DropDownItem) => dispatch(setLegalTab(item.id))}
            />

            <div className={styles.content} ref={contentRef}>
                {tab === 'Privacy_Policy' && <PrivacyPolicy />}
                {tab === 'Employer_Terms' && <EmployerTerms />}
                {tab === 'Applicant_Terms' && <ApplicantTerms />}
            </div>
        </div>
    );
};
